module.exports = __webpack_public_path__ + "media/won.8c096435.wav";